import { defineStore } from 'pinia';

export const useViewerTheaterModeStore = defineStore('viewerTheaterMode', {
  state: () => ({
    isTheaterMode: false,
  }),
  actions: {
    toggleTheaterMode() {
      this.isTheaterMode = !this.isTheaterMode;
    },
    disableTheaterMode() {
      this.isTheaterMode = false;
    },
  },
});
